import React from 'react';
import { Paper, Stack, TextField, FormControlLabel, Switch, Button, Typography } from '@mui/material';

export default function Configuracoes() {
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>Configurações do PMS (Mock)</Typography>
      <Stack spacing={2}>
        <TextField size="small" label="Nome do Hotel" defaultValue="Hotel Lisboa" />
        <TextField size="small" label="E-mail de Contato" defaultValue="contato@hotel.com" />
        <FormControlLabel control={<Switch defaultChecked />} label="Receber reservas on-line" />
        <FormControlLabel control={<Switch />} label="Enviar e-mail automático de boas-vindas" />
        <Stack direction="row" spacing={1}>
          <Button variant="contained">Salvar</Button>
          <Button variant="outlined">Cancelar</Button>
        </Stack>
      </Stack>
    </Paper>
  );
}
